






















































































































































































import Vue from 'vue';
import moment from 'moment';
import { getLocationTimezoneName } from '../helpers';
import { EntranceEntity, TimeslotEntity, ReservationEntity, LocationEntity } from '../../../types';

const baseWebURL = process.env.VUE_APP_BASE_URL;

export default Vue.extend({
  name: 'thank-you',
  props: {
    reservationId: {
      type: String,
      required: true,
    },
    reservationLocationId: {
      type: String,
      required: true,
    },
    reservationTimeslotId: {
      type: String,
      required: true,
    },
    reservationEntranceId: {
      type: String,
      required: false,
    },
  },
  computed: {
    innerReservation(): ReservationEntity {
      return (this as any).externalUserReservations.find(
        (externalUserReservation: ReservationEntity) => externalUserReservation.id === parseInt(this.reservationId, 10),
      );
    },
    location(): LocationEntity {
      return (this as any).locations.find((location: LocationEntity) => location.id === parseInt(this.reservationLocationId, 10));
    },
    timeslot(): TimeslotEntity {
      return (this as any).timeslots.find((timeslot: TimeslotEntity) => timeslot.id === parseInt(this.reservationTimeslotId, 10));
    },
    allDayTimeslot(): boolean {
      return ['00:00:00', '00:00:01'].includes(this.timeslot.startTime) && ['23:59:59', '00:00:00'].includes(this.timeslot.endTime);
    },
    entrance(): EntranceEntity | undefined {
      return (this as any).entrances.find((entrance: EntranceEntity) => entrance.id === parseInt(this.reservationEntranceId, 10));
    },
    calendarDescription(): string {
      return `${this.$t('text.reservation_details')}: ${baseWebURL}/reservation/${this.innerReservation.qrCode}?customerId=${
        this.innerReservation.customerId
      }<br><br>${this.$t('text.important_notes')}:<br><br>${this.$t('text.arrive_by')} ${(this as any).formatMomentWithLocale(
        moment(`1970-01-01T${this.timeslot.startTime}`),
        'LT',
        this.location.disableMilitaryTime === true,
      )}.<br>${this.$t('text.use_the')} ${
        this.entrance && this.entrance.name.toLowerCase() !== 'main' ? this.entrance.name : this.$t('text.main')
      } ${(this.$t('text.entrance') as string).toLowerCase()}.<br>${this.$t('text.leave_location_by')} ${(this as any).formatMomentWithLocale(
        moment(`1970-01-01T${this.timeslot.endTime}`),
        'LT',
        this.location.disableMilitaryTime === true,
      )}.`;
    },
  },
  mounted() {
    (window as any).addeventatc.refresh();
  },
  methods: {
    newReservation(): void {
      this.$router.push({
        name: 'reserve',
        query: {
          apiKey: (this as any).apiKey,
          customerId: (this as any).customerId,
          occupantTypeId: (this as any).occupantTypeId,
          lang: (this as any).innerReservation.lang,
          webview: (this as any).webview,
          primaryColor: (this as any).primaryColor.replace('#', ''),
          primaryFontColor: (this as any).primaryFontColor.replace('#', ''),
          primaryButtonFontColor: (this as any).primaryButtonFontColor.replace('#', ''),
          secondColor: (this as any).secondColor.replace('#', ''),
          secondFontColor: (this as any).secondFontColor.replace('#', ''),
          secondButtonFontColor: (this as any).secondButtonFontColor.replace('#', ''),
          thirdColor: (this as any).thirdColor.replace('#', ''),
          thirdFontColor: (this as any).thirdFontColor.replace('#', ''),
          thirdButtonFontColor: (this as any).thirdButtonFontColor.replace('#', ''),
          fourthColor: (this as any).fourthColor.replace('#', ''),
          fourthFontColor: (this as any).fourthFontColor.replace('#', ''),
          fourthButtonFontColor: (this as any).fourthButtonFontColor.replace('#', ''),
          headerBackgroundColor: (this as any).headerBackgroundColor.replace('#', ''),
          languagePickerColor: (this as any).languagePickerColor.replace('#', ''),
          ...((this as any).innerReservation.externalUserId && {
            externalUserId: (this as any).innerReservation.externalUserId,
          }),
          ...((this as any).widgetLayout && {
            widgetLayout: (this as any).widgetLayout,
          }),
          ...((this as any).cssURL && { cssURL: (this as any).cssURL }),
          ...((this as any).visitTypeId && { visitTypeId: (this as any).visitTypeId }),
          ...((this as any).fcmToken && { fcmToken: (this as any).fcmToken }),
          ...((this as any).queryParametersName && { name: (this as any).queryParametersName }),
          ...((this as any).queryParametersEmail && { email: (this as any).queryParametersEmail }),
          ...((this as any).locationId && { locationId: (this as any).locationId }),
        },
      });
    },
    manageReservations(): void {
      this.$router.push({
        name: 'manage-reservations',
        params: {
          pathExternalUserId: this.innerReservation.externalUserId!,
        },
        query: {
          customerId: this.innerReservation.customerId.toString(),
        },
      });
    },
    getLocationTimezoneName,
  },
});
